import React from "react";
import cn from 'clsx';

interface Props {
  disabled?: boolean;
  isActive?: boolean;
  isRed?: boolean;
  activeTxt?: string;
  notActiveTxt?: string;
  handleClick: () => void;
  hasError?: boolean;
}

const SwitchBtn: React.FC<Props> = ({
  disabled,
  handleClick,
  isActive,
  isRed,
  notActiveTxt,
  activeTxt,
  hasError,
}) => {
  return (
    <div
      className={cn(
    "switch-btn-wrapper",
    isRed && "red",
    disabled && "disabled",
    isActive && "active",
    !notActiveTxt && "no-text",
    hasError && "switch-error"
  )}
    >
      <div className="switch-label">
        {!notActiveTxt ? (
          <span className="active">{activeTxt ?? ""}</span>
        ) : (
          <>
            <span>{notActiveTxt}</span>{" "}
            <span className="switch-divider"> / </span> 
            <span>{activeTxt}</span>
          </>
        )}
      </div>
      <div
        className="switch-btn"
        onClick={disabled ? undefined : handleClick}
        aria-disabled={disabled}
      />
    </div>
  );
};

export default SwitchBtn;
